import { database } from '@app/firebase';
import { collection, deleteDoc, doc, setDoc } from 'firebase/firestore';

export async function addSavedHome(uid: string, home: guesthouse.HomeLite) {
  return setDoc(
    doc(collection(doc(collection(database, 'users'), uid), 'savedHomes'), home.docID),
    home
  );
}

export async function removeSavedHome(uid: string, home: guesthouse.HomeLite) {
  return deleteDoc(doc(collection(doc(collection(database, 'users'), uid), 'savedHomes'), home.docID));
}

export async function addSavedRoom(uid: string, room: Partial<guesthouse.UserRoom>) {
  return setDoc(
    doc(collection(doc(collection(database, 'users'), uid), 'savedRooms'), room.docID),
    room
  );
}

export async function removeSavedRoom(uid: string, room: Partial<guesthouse.UserRoom>) {
  return deleteDoc(doc(collection(doc(collection(database, 'users'), uid), 'savedRooms'), room.docID));
}

export async function addSavedProduct(uid: string, product: guesthouse.Product | guesthouse.ProductLite) {
  return setDoc(
    doc(collection(doc(collection(database, 'users'), uid), 'savedProducts'), product.docID),
    product
  );
}

export async function removeSavedProduct(uid: string, product: guesthouse.Product | guesthouse.ProductLite) {
  return deleteDoc(doc(collection(doc(collection(database, 'users'), uid), 'savedProducts'), product.docID));
}

export async function addSavedUser(uid: string, user: guesthouse.User) {
  return setDoc(
    doc(collection(doc(collection(database, 'users'), uid), 'savedUsers'), user.docID),
    user
  );
}

export async function removeSavedUser(uid: string, user: guesthouse.User) {
  return deleteDoc(doc(collection(doc(collection(database, 'users'), uid), 'savedUsers'), user.docID));
}
